import React from 'react';
import { Grid } from '@mui/material';
import GroupedPageLines from '../@common/GroupedPageLines';
import { SmallPageLineText } from '../@common/PageLineText';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

const ReasonRow = ({ fontSize, fontFamily, marginTop, isNarrow }) => {
  return (
    <Grid container spacing={1}>
      <Grid container item spacing={3}>
        <Grid item xs={3}>
          <GroupedPageLines
            top={8}
            width={200}
            fontSize={fontSize}
            color="black"
            marginLeftText={3}
            marginTopText={marginTop}
            marginPageLines="10px 25px 0px"
            fontFamily={fontFamily}
            isNarrow={isNarrow}
          >
            {t('reasons')}:
          </GroupedPageLines>
        </Grid>
        <Grid item xs={1} style={{ marginTop: 19, marginLeft: 80 }}>
          <SmallPageLineText isNarrow={isNarrow}>
            <div style={{ marginLeft: '-45px' }}>1.</div>
          </SmallPageLineText>
        </Grid>
        <Grid item xs={8} style={{ marginTop: 8, marginLeft: -125 }}>
          <GroupedPageLines marginTopText={'0 px'} width={530} isNarrow={isNarrow} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReasonRow;
